import React, { useState } from 'react';
import './ResponsiveFontControls.css';

function ResponsiveFontControls({ 
    label, 
    sizeField, 
    weightField, 
    editData, 
    handleInputChange,
    defaultSize = '16',
    defaultWeight = '400'
}) {
    const [activeScreen, setActiveScreen] = useState('normal');

    // Breakpoint-spezifische Feldnamen
    const getFieldName = (baseField, screen) => {
        // ✅ FIXED: Entferne blockierende Validierung - baseField kann leer sein
        if (!baseField || typeof baseField !== 'string') {
            return null; // Stille Behandlung ohne Console-Error
        }
        
        switch(screen) {
            case 'mobile': return `${baseField}Mobile`;
            case 'normal': return baseField;
            case 'big': return `${baseField}Big`;
            default: return baseField;
        }
    };

    const getCurrentValue = (baseField, screen) => {
        const fieldName = getFieldName(baseField, screen);
        // ✅ FIXED: Fallback für ungültige fieldNames
        if (!fieldName) {
            return screen === 'normal' ? defaultSize : '';
        }
        return editData[fieldName] || (screen === 'normal' ? defaultSize : '');
    };

    return (
        <div className="responsive-font-controls">
            <h3>{label}</h3>
            
            {/* Screen Size Buttons */}
            <div className="screen-size-buttons">
                <button 
                    type="button"
                    className={`screen-button ${activeScreen === 'mobile' ? 'active' : ''}`}
                    onClick={() => setActiveScreen('mobile')}
                >
                    <div className="screen-button-content">
                        <span className="screen-icon">📱</span>
                        <span className="screen-text">Mobile</span>
                    </div>
                </button>
                <button 
                    type="button"
                    className={`screen-button ${activeScreen === 'normal' ? 'active' : ''}`}
                    onClick={() => setActiveScreen('normal')}
                >
                    <div className="screen-button-content">
                        <span className="screen-icon">💻</span>
                        <span className="screen-text">Normal</span>
                    </div>
                </button>
                <button 
                    type="button"
                    className={`screen-button ${activeScreen === 'big' ? 'active' : ''}`}
                    onClick={() => setActiveScreen('big')}
                >
                    <div className="screen-button-content">
                        <span className="screen-icon">📺</span>
                        <span className="screen-text">Big</span>
                    </div>
                </button>
            </div>

            {/* Font Controls für aktiven Screen */}
            <div className="font-controls-content">
                <div className="font-control-group">
                    <div className="input-group">
                        <label htmlFor={getFieldName(sizeField, activeScreen)}>Size</label>
                        <input 
                            id={getFieldName(sizeField, activeScreen)}
                            type="text" 
                            name={getFieldName(sizeField, activeScreen) || `${sizeField}${activeScreen === 'mobile' ? 'Mobile' : activeScreen === 'big' ? 'Big' : ''}`}
                            value={getCurrentValue(sizeField, activeScreen)}
                            onChange={handleInputChange}
                            className="text-component-1"
                            placeholder={activeScreen === 'normal' ? defaultSize : 'Auto'}
                        />
                    </div>
                    <hr className="hrrrrr"/>
                    <div className="input-group">
                        <label htmlFor={getFieldName(weightField, activeScreen)} id="alt-label">Thick</label>
                        <input 
                            id={getFieldName(weightField, activeScreen)}
                            type="text" 
                            name={getFieldName(weightField, activeScreen) || `${weightField}${activeScreen === 'mobile' ? 'Mobile' : activeScreen === 'big' ? 'Big' : ''}`}
                            value={getCurrentValue(weightField, activeScreen)}
                            onChange={handleInputChange}
                            className="text-component-2"
                            placeholder={activeScreen === 'normal' ? defaultWeight : 'Auto'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResponsiveFontControls;
